import React from 'react';
import NftCard from '../../components/NftCard';
import { PageWrapper } from './styles';

const cardData = [
  {
    id: 1234,
    author: {
      firstName: 'Mia',
      lastName: 'Ariannaa',
      title: 'Freestyle 1 two 10',
      avatarUrl: 'https://res.cloudinary.com/scall/image/upload/v1612183223/sCallProfiles/Mia%20Ariannaa/profile_pic_mia.ariannaa_le2jpg.png',
    },
    coverMedia: {
      coverImageURL: '',
      videoUrl: 'https://res.cloudinary.com/scall/video/upload/v1615560909/sCallProfiles/amadeu_test/mia_flow_fmo0oc.mp4',
    },
    chainInfo: {
      contractAddress: '0x5574...06288',
      blockchain: 'Ethereum',
      inventory: '1k TOTAL',
      price: 'Ξ 0.55',
    },
    collection: {
      name: 'freestyle, 1/10',
      number: '1/10',
    },
    details: {
      about: 'If you don’t have the hunger on your face, in your eyes and in your soul, what’s the point???? Hold on to that hunger',
      createdOn: '03/19/2020',
      collection: 'street dance',
    },
  },
  {
    id: 1244,
    author: {
      firstName: 'Mia',
      lastName: 'Ariannaa',
      title: 'Freestyle 1 two 10',
      avatarUrl: 'https://res.cloudinary.com/scall/image/upload/v1612183223/sCallProfiles/Mia%20Ariannaa/profile_pic_mia.ariannaa_le2jpg.png',
    },
    coverMedia: {
      coverImageURL: '',
      videoUrl: 'https://res.cloudinary.com/scall/video/upload/v1615561952/sCallProfiles/amadeu_test/mia_flow3_ljpard.mp4',
    },
    chainInfo: {
      contractAddress: '0x5574...06288',
      blockchain: 'Ethereum',
      inventory: '1k TOTAL',
      price: 'Ξ 0.55',
    },
    collection: {
      name: 'freestyle, 1/10',
      number: '1/10',
    },
    details: {
      about: 'If you don’t have the hunger on your face, in your eyes and in your soul, what’s the point???? Hold on to that hunger',
      createdOn: '03/19/2020',
      collection: 'street dance',
    },
  },
  {
    id: 3234,
    author: {
      firstName: 'Mia',
      lastName: 'Ariannaa',
      title: 'Freestyle 1 two 10',
      avatarUrl: 'https://res.cloudinary.com/scall/image/upload/v1612183223/sCallProfiles/Mia%20Ariannaa/profile_pic_mia.ariannaa_le2jpg.png',
    },
    coverMedia: {
      coverImageURL: '',
      videoUrl: 'https://res.cloudinary.com/scall/video/upload/v1615561928/sCallProfiles/amadeu_test/mia_flow2_rhfutm.mp4',
    },
    chainInfo: {
      contractAddress: '0x5574...06288',
      blockchain: 'Ethereum',
      inventory: '1k TOTAL',
      price: 'Ξ 0.55',
    },
    collection: {
      name: 'freestyle, 1/10',
      number: '1/10',
    },
    details: {
      about: 'If you don’t have the hunger on your face, in your eyes and in your soul, what’s the point???? Hold on to that hunger',
      createdOn: '03/19/2020',
      collection: 'street dance',
    },
  },
  {
    id: 1264,
    author: {
      firstName: 'Mia',
      lastName: 'Ariannaa',
      title: 'Freestyle 1 two 10',
      avatarUrl: 'https://res.cloudinary.com/scall/image/upload/v1612183223/sCallProfiles/Mia%20Ariannaa/profile_pic_mia.ariannaa_le2jpg.png',
    },
    coverMedia: {
      coverImageURL: '',
      videoUrl: 'https://res.cloudinary.com/scall/video/upload/v1615561918/sCallProfiles/amadeu_test/mia_flow4_kajonf.mp4',
    },
    chainInfo: {
      contractAddress: '0x5574...06288',
      blockchain: 'Ethereum',
      inventory: '1k TOTAL',
      price: 'Ξ 0.55',
    },
    collection: {
      name: 'freestyle, 1/10',
      number: '1/10',
    },
    details: {
      about: 'If you don’t have the hunger on your face, in your eyes and in your soul, what’s the point???? Hold on to that hunger',
      createdOn: '03/19/2020',
      collection: 'street dance',
    },
  },
];

const NftMiaPage = () => (
  <PageWrapper>
    {cardData.map((c) => <NftCard key={c.id} cardData={c} />)}
  </PageWrapper>
);

export default NftMiaPage;
